import React from 'react';
import './GroupOfAcceptedBanks.style.scss';

export const GroupOfAcceptedBanks = () => {
  return (
    <section className="group-banks">
      <header className="group-banks__box-title">
        <h2 className="group-banks__title">Bancos</h2>
      </header>
      <article className="group-banks__content">
        <p className="group-banks__text">
          Abaixo, os bancos que atualmente aceitamos no credenciamento dos
          nossos produtos. É possível alterar o banco após o credenciamento,
          basta entrar em contato com a central de atendimento.
        </p>
        <ul className="group-banks__list">
          <li>001 - Banco do Brasil</li>
          <li>033 - Banco Santander (Brasil) S.A.</li>
          <li>041 - Banco do Estado do Rio Grande do Sul S.A.</li>
          <li>104 - Caixa Econômica Federal</li>
          <li>212 - Banco Original</li>
          <li>237 - Banco Bradesco S.A.</li>
          <li>341 - Itaú Unibanco S.A.</li>
          <li>634 - Banco Triângulo S.A.</li>
          <li>756 - Banco Cooperativo do Brasil S.A. - BANCOOB</li>
          <li>748 - Banco Cooperativo Sicredi S.A.</li>
        </ul>
      </article>
    </section>
  );
};
